import styled from 'styled-components';
import { Box, themedColor, easeOutQuad } from '@lemonade-hq/cdk';
import { lerp, clampedInversedLerp } from '@lemonade-hq/ts-helpers';

const Container = styled(Box)`
  position: relative;
  will-change: contents;
`;

const Bubble = styled(Box)`
  position: absolute;
  border-radius: 100%;
  background-color: ${themedColor('primary')};
  will-change: transform;
`;

export default function Giveback2020Zoo({ t, ...props }) {
  return (
    <Container {...props}>
      <Bubble
        width={[190, 190, 524]}
        height={[190, 190, 524]}
        top={[0, 0, 0]}
        left={[634, 634, 1281]}
        style={{
          transform: `scale(${lerp(0, 1, easeOutQuad(clampedInversedLerp(0.0, 0.2, t)))})`,
        }}
      />
      <Bubble
        width={[60, 60, 164]}
        height={[60, 60, 164]}
        top={[196, 196, 540]}
        left={[526, 526, 983]}
        style={{
          transform: `scale(${lerp(0, 1, easeOutQuad(clampedInversedLerp(0.15, 0.5, t)))})`,
        }}
      />
      <Bubble
        width={[412, 412, 1136]}
        height={[412, 412, 1136]}
        top={[44, 44, 126]}
        left={[-20, -20, -552]}
        style={{
          transform: `scale(${lerp(0, 1, easeOutQuad(clampedInversedLerp(0.2, 0.4, t)))})`,
        }}
      />
      <Bubble
        width={[302, 302, 302]}
        height={[302, 302, 302]}
        top={[520, 520, 1270]}
        left={[-10, -10, 270]}
        style={{
          transform: `scale(${lerp(0, 1, easeOutQuad(clampedInversedLerp(0.7, 0.9, t)))})`,
        }}
      />
      <Bubble
        width={[452, 452, 1244]}
        height={[452, 452, 1244]}
        top={[300, 300, 772]}
        left={[530, 530, 926]}
        style={{
          transform: `scale(${lerp(0, 1, easeOutQuad(clampedInversedLerp(0.45, 1, t)))})`,
        }}
      />
      <Bubble
        width={[110, 110, 684]}
        height={[110, 110, 684]}
        top={[455, 455, 1437]}
        left={[300, 300, -438]}
        style={{
          transform: `scale(${lerp(0, 1, easeOutQuad(clampedInversedLerp(0.8, 1, t)))})`,
        }}
      />
    </Container>
  );
}
